import i18next from '@packages/core/i18n';

import allowList from './en/allow-list.json';

const resourceCenter = {
  allowList,
};

i18next.addResourceBundle('en', 'resourceCenter', resourceCenter);

export default i18next;
